const COPILOT_BASE = '/copilot-proxy';
const COPILOT_MODEL = 'gpt-4o';
const COPILOT_TOKEN_KEY = '__ddCopilotToken';

export function getStoredCopilotToken() {
  return localStorage.getItem(COPILOT_TOKEN_KEY) || '';
}

export function storeCopilotToken(token) {
  localStorage.setItem(COPILOT_TOKEN_KEY, token);
}

export function clearCopilotToken() {
  localStorage.removeItem(COPILOT_TOKEN_KEY);
}

function copilotFetch(path, options = {}) {
  const token = getStoredCopilotToken();
  if (!token) return Promise.reject(new Error('No GitHub token. Enter your token in the AI panel.'));
  return fetch(`${COPILOT_BASE}${path}`, {
    ...options,
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      ...(options.headers || {}),
    },
  });
}

export async function callCopilot(systemPrompt, userMessage) {
  const res = await copilotFetch('/chat/completions', {
    method: 'POST',
    body: JSON.stringify({
      model: COPILOT_MODEL,
      messages: [
        { role: 'system', content: systemPrompt },
        { role: 'user', content: userMessage },
      ],
    }),
  });
  if (!res.ok) throw new Error(`Copilot ${res.status}: ${await res.text()}`);
  const data = await res.json();
  return data.choices?.[0]?.message?.content ?? '';
}
